import React from "react";

const ContentBlockError = ({ shortcode, blockId, reason }) => (
    <div className="content-block-error" role="alert">
        <strong>Content block unavailable.</strong>{" "}
        <span>
            Check <code>[{shortcode}]</code>
            {blockId && (
                <>
                    {" "}
                    with Block ID <code>{blockId}</code>
                </>
            )}
            {reason && `: ${reason}`}.
        </span>
    </div>
);

export default ContentBlockError;
